import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { defineEnemy, Motion, Pattern } from '../schema';

/** E-M9 — REMPART. L'Égide poussée à bout.
 *
 *  L'Égide protège un cône de ±55° : une gerbe large lui touche les épaules sans
 *  y penser, une gerbe étroite doit se décaler d'une soixantaine d'unités. Le
 *  Rempart ferme presque tout — ±80°. Il ne reste plus d'épaule à viser : la
 *  quasi-totalité de sa face inférieure est couverte, et aucun décalage de tir
 *  droit, si large soit-il, ne suffit. Il faut le CONTOURNER — monter à sa
 *  hauteur, passer sur le flanc, frapper là où le cône ne regarde pas.
 *
 *  ── Ce qu'il enseigne ──
 *  Que « bien se placer pour toucher » (la leçon de l'Égide) peut devoir aller
 *  jusqu'à quitter complètement le dessous de l'ennemi. Là où l'Égide se résout
 *  d'un pas de côté et d'une arme large, le Rempart exige un déplacement franc :
 *  se hisser sur son flanc, s'exposer un instant à ses tirs pour trouver l'angle,
 *  puis frapper. C'est la même compétence que l'Égide, portée à son terme.
 *
 *  ── Pourquoi ±80° et pas 90 ──
 *  À 90°, tout ce qui vient d'en dessous serait bloqué sans exception et le seul
 *  recours serait de frapper strictement par le côté ou par le haut — une
 *  contrainte si raide qu'elle se lirait comme un bug (« mes tirs ne marchent
 *  pas »). À 80° il reste une mince fenêtre près de l'horizontale : le
 *  contournement est dur mais possible, et il se VOIT.
 *
 *  ── Pourquoi une pression légère ──
 *  Comme l'Égide : deux tirs visés espacés, juste de quoi interdire de camper le
 *  flanc en sécurité pendant qu'on cherche l'angle. Le Rempart est un problème de
 *  placement, pas d'esquive ; le noyer sous un rideau ferait choisir survivre
 *  plutôt que contourner, et il perdrait sa raison d'être. Il vaut donc, lui
 *  aussi, mieux accompagné. */
export default defineEnemy({
  id: 'rempart',
  rank: Rank.Heavy,
  hp: 380,
  visualRadius: 46,
  score: 460,
  telegraph: 1.1,
  drops: 4,
  /* Dérive lente et large : le Rempart se déplace assez pour qu'on ne mémorise
     pas un flanc sûr, assez peu pour qu'on puisse aller le chercher. */
  motion: { kind: Motion.Hover, speed: 250, amplitude: 70, frequency: 0.5, holdY: 360 },
  /* 500 PV de bouclier : casser de front reste une option (lente), mais le cône
     est si large que le contournement devient la route naturelle — l'inverse de
     l'Égide, où contourner est l'option et casser la route par défaut. */
  shieldHp: 500,
  /* ±80° : presque toute la face inférieure. Voir plus haut pour le choix de ne
     pas monter à 90. */
  shieldConeDeg: 80,
  emitter: {
    pattern: Pattern.Aimed,
    every: 1.6,
    count: 2,
    spreadDeg: 16,
    speed: 450,
    firstDelay: 1.4,
    family: Fam.EnemyPink,
  },
});
